export const imageCodes = {
    
    appstore: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fappstore.png?alt=media&token=a5a580a3-df53-4c16-a2fa-33ec0a3ca949"
    },
    playstore: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fplaystore.png?alt=media&token=ca4c750a-e2ed-4de0-883d-5a2f565021d6"
    },
    banPhoto: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmem2.png?alt=media&token=808d3b0b-8ef2-4b69-b6c0-63b823652088"
    },
    pointImg: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmem1.png?alt=media&token=bd643bcb-f66f-4115-ba71-4405f98d6c43"
    },
    logoImg: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flogo.png?alt=media&token=f1bc1b18-8d8f-4ab0-a8d0-6518f82401ec"
    },
}

export const textCodes = {
    Join: {
        code: "${merchantId}_tmpl_text_2",
        text: "Join Our"
    },
    loyaltyDes1: {
        code: "${merchantId}_tmpl_text_3",
        text: "BOND Product များကို အလွယ်တကူဝယ်ယူနိုင်ဖို့ App လေး လုပ်ပေးထားပါတယ်ခင်ဗျာ"
    },
    loyaltyDes2: {
        code: "${merchantId}_tmpl_text_4",
        text: "——————>"
    },
    
   
    loyaltyDes4: {
        code: "${merchantId}_tmpl_text_7",
        text: "နောက်ပိုင်းPromotionတွေ Point တွေ ရှယ်အပေးကြမ်းမှာပါ ☺️ BOND ကိုအမြဲသုံးဖြစ်တယ်ဆို ဒေါင်းလော့ဆွဲကိုဆွဲထားသင့်ပါတယ်ခင်ဗျာ🥰 ဒေါင်းလော့ဆွဲရန်⭐️"
    },
    earnPointsMember: {
        code: "${merchantId}_tmpl_text_5",
        text: "—— Earn Points"
    },
    reward1: {
        code: "${merchantId}_tmpl_text_8",
        text: "ဝယ်ယူတဲ့ ပစ္စည်းအမျိုးအစားပေါ်မူတည်၍ မတူညီတဲ့ Points များရရှိပါမည်။ အခုဝင်ဝင်ချင်း 500Point လက်ဆောင်ရပါမယ်ခင်ဗျာ မန္တလေး ၇မြို့နယ်က ၁လပို့ခ Free ပို့ပေးမှာပါ..."
    },
    exp: {
        code: "${merchantId}_tmpl_text_9",
        text: "* point will expire after 12 months"
    },
    rewartText: {
        code: "${merchantId}_tmpl_text_10",
        text: "Welcome Gift"
    },
    spent: {
        code: "${merchantId}_tmpl_text_11",
        text: "500 Points"
    },
    rewartText1: {
        code: "${merchantId}_tmpl_text_12",
        text: "500Ks Discount"
    },
    rewartText2: {
        code: "${merchantId}_tmpl_text_13",
        text: "1000Ks Discount"
    },
    spent1: {
        code: "${merchantId}_tmpl_text_14",
        text: "1000 Points"
    },
}

export const titleCodes = {
    member: {
        code: "${merchantId}_tmpl_title_2",
        title: "Digital Membership"
    },

    reward: {
        code: "${merchantId}_tmpl_title_3",
        title: "Why You Should Become A Member?"
    },
    
   
}